import React from 'react'
import type { QuickbetState } from '@core/Areas/Quickbet/driver'
import { isFobDetails, isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import {
  isFavouriteNumbersDetails,
  isMysteryDetails,
  isToteSportsDetails,
} from '@core/Data/Betting/selectionDetails'
import {
  FavouriteNumbersHeader,
  FobHeader,
  MysteryHeader,
  RacingHeader,
  ToteSportsHeader,
} from './Components'

export const BetInfoHeader: React.FC<Pick<QuickbetState, 'selectionDetails'>> = ({
  selectionDetails,
}) => {
  if (isRaceDetails(selectionDetails)) {
    return <RacingHeader />
  }

  if (isMysteryDetails(selectionDetails)) {
    return <MysteryHeader />
  }

  if (isFobDetails(selectionDetails)) {
    return <FobHeader />
  }

  if (isFavouriteNumbersDetails(selectionDetails)) {
    return <FavouriteNumbersHeader />
  }

  if (isToteSportsDetails(selectionDetails)) {
    return <ToteSportsHeader />
  }

  return null
}
